(function () {
  const ROOT = "[data-slideshow-slick]";
  const TRACK = "[data-slideshow-slick-track]";

  function destroy(root) {
    if (!window.jQuery) return;
    const $ = window.jQuery;
    const $slider = $(root).find(TRACK);
    $slider.off(".slideshowSlickSlick");
    if ($slider.hasClass("slick-initialized")) $slider.slick("unslick");
    root.removeAttribute("data-slick-mounted");
  }

  function mount(root) {
    if (!window.jQuery?.fn?.slick || root.getAttribute("data-slick-mounted"))
      return;
    const $ = window.jQuery;
    const $slider = $(root).find(TRACK);
    if ($slider.children().length < 2) {
      root.setAttribute("data-slick-mounted", "1");
      return;
    }

    const autoplay =
      root.dataset.autoplay === "true" || root.dataset.autoplay === true;
    const autoplaySpeed =
      +root.dataset.autoplaySpeed > 0 ? +root.dataset.autoplaySpeed : 5000;
    const $dots = $(root).find("[data-slideshow-slick-dots]");
    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "20%",
      adaptiveHeight: true,
      autoplay,
      autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows: false,
      dots: !!$dots.length,
      appendDots: $dots.length ? $dots : undefined,
      speed: 450,
      cssEase: "ease-out",
      responsive: [{ breakpoint: 750, settings: { centerPadding: "10%" } }],
    });
    root.setAttribute("data-slick-mounted", "1");
  }

  function scan(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(mount);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan());
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (ev) => {
    const el = ev.target;
    if (!el?.querySelector) return;
    const root = el.matches?.(ROOT) ? el : el.querySelector(ROOT);
    if (root) {
      destroy(root);
      mount(root);
    }
  });

  document.addEventListener("shopify:section:unload", (ev) => {
    const el = ev.target;
    if (!el?.querySelector) return;
    const root = el.querySelector(ROOT);
    if (root) destroy(root);
  });
})();
